import {Component, OnDestroy, OnInit} from '@angular/core';

import {interval, Subject, Subscription, takeWhile} from 'rxjs';

import {SigningService} from './signing.service';
import {UserService} from '../../../../shared/service/user.service';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';
import {AppSubject} from '../../../../shared/app-subject';
import {FormBuilder, Validators} from '@angular/forms';
import {validateAllFormFields} from '../../../../shared/components/validator/validator.service';
import {InvoiceService} from '../../../customer/invoice/invoice.service';

@Component({
  selector: 'app-signing',
  templateUrl: './signing.component.html'
})
export class SigningComponent implements OnInit, OnDestroy {

  errorSubscription?: Subscription;
  displaySubscription?: Subscription;
  reloadSubscription?: Subscription;
  items: Array<any> = [];
  selectedCTS: any;
  pluginNotFound?: boolean;
  display?: boolean;
  display2?: boolean;
  display3?: boolean;
  display4?: boolean;
  displayPinCode?: boolean = false;
  signingTypes: Array<any> = [];
  ctsList: any[] = [];

  selected: any
  signingData = {
    partyOtherIndentId: '',
    idValue: '',
    idValues: '',
    partyClassificationId: '',
    signingType: '',
    pinCode: '',
  }
  form = this.fb.group({
    pinCode: ['', Validators.required],
  });
  private timerSubscription!: Subscription;
  timeLeft: number = 180; // 3 minutes in seconds
  minutes: number = 3;
  seconds: number = 0;
  isLoading: boolean = true; // Show spinner initially

  constructor(
    private certificatedService: SigningService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private invoiceService: InvoiceService,
  ) {
  }

  submit(): void {
    if (!this.selected) {
      this.selected = this.signingTypes[0].value
    }
    UserService.set(UserService.KEY.SIGNING, this.selected)
    this.signingData.partyClassificationId = this.selected
    const runValue = JSON.parse(UserService.get('RUN_VALUE'))
    if (this.selected ==='UsbTokenSigning' && runValue.actionType ==="invoiceBatchSigning"){
      this.invoiceService.putToWorkEffort(runValue.idValues).subscribe(({workEffortId}) => {
        if (workEffortId) {
          this.certificatedService.run({
            idValue: workEffortId,
            actionType: 'invoiceBatchSigning',
            suppressPopup: true
          })
        } else {
          this.toastService.error();
        }
      });
    } else {
      this.certificatedService.run(runValue)
      UserService.set(UserService.KEY.SIGNING, '')
    }
    this.display = false
  }

  submit2(): void {
    if (this.displayPinCode) {
      if (validateAllFormFields(this.form)) {
        this.signingData.pinCode = this.form.value.pinCode
        this.display2 = false
        this.signingData.partyOtherIndentId = this.selectedCTS.value
        this.signingData.idValue = JSON.parse(UserService.get('RUN_VALUE'))?.idValue
        this.signingData.idValues = JSON.parse(UserService.get('RUN_VALUE'))?.idValues
        this.signingData.signingType = JSON.parse(UserService.get('RUN_VALUE'))?.actionType
        this.display4 = true

        this.certificatedService.remoteSigning(this.signingData).subscribe({
          next: () => {
            this.toastService.success();
            this.display4 = false
            AppSubject.setReloadData('success')
          }
          , error: async error => {
            this.toastService.setMessage({severity: Severity.ERROR, detail: error.error.errors});
            this.display4 = false
            AppSubject.setReloadData('error')
          }
        })
      }
    } else {
      this.display2 = false
      this.signingData.partyOtherIndentId = this.selectedCTS.value
      this.signingData.idValue = JSON.parse(UserService.get('RUN_VALUE'))?.idValue
      this.signingData.idValues = JSON.parse(UserService.get('RUN_VALUE'))?.idValues
      this.signingData.signingType = JSON.parse(UserService.get('RUN_VALUE'))?.actionType
      this.display3 = true
      this.timeLeft = 180; // 3 minutes in seconds
      this.minutes = 3;
      this.seconds = 0;
      this.startTimer()
      this.certificatedService.remoteSigning(this.signingData).subscribe({
        next: () => {
          this.toastService.success();
          this.display3 = false
          AppSubject.setReloadData('success')
        }
        , error: async error => {
          this.toastService.setMessage({severity: Severity.ERROR, detail: error.error.errors});
          this.display3 = false
          AppSubject.setReloadData('error')
        }
      })
    }

  }

  onCTSChange(selectedValue: string) {
    const selected = this.ctsList.find(item => item.partyOtherIndentId === selectedValue);
    this.displayPinCode = selected?.requirePinCode === "Y";
  }

  typeSelect(event: any): void {
    this.selected = event.value
  }

  ngOnInit(): void {
    UserService.set(UserService.KEY.SIGNING, '')
    UserService.set(UserService.KEY.REMOTE_SIGNING, '')
    if (UserService.get('SIGNING_TYPES')!=='NULL') {
      const arr = JSON.parse(UserService.get('SIGNING_TYPES'))
      arr.map((item: any) => {
        this.signingTypes.push({
          value: item.partyClassificationId, label: item.classificationDesc
        })
      })
    }
    this.errorSubscription = this.certificatedService.errorSubject.subscribe(error => {
      if (error) {
        if (error.status === 0) {
          this.pluginNotFound = true;
        }
        if (error?.name === "TimeoutError") {
          this.pluginNotFound = true
        }
        console.log(error);
      }
    });
    this.displaySubscription = this.certificatedService.displaySubject.subscribe(res => {

      if (res === 'form1') {
        this.display = true
        this.pluginNotFound = false
      } else if (res === 'form2') {
        if (UserService.get('REMOTE_SIGNING')) {

          const arr = JSON.parse(UserService.get('REMOTE_SIGNING'))
          this.ctsList = arr;
          this.selectedCTS = arr[0].partyOtherIndentId
          if (this.items.length === 0) {
            arr.map((item: any) => {
              this.items.push({
                value: item.partyOtherIndentId, label: item.idValue
              })
            })
          }
          this.displayPinCode = arr[0]?.requirePinCode === "Y";

        }

        this.display = false
        this.display2 = true
      } else if (res === 'form3') {
        this.display4 = true
      } else if (res === 'closeForm3') {
        this.display4 = false
      }
    });
    setTimeout(() => this.certificatedService.promptResumeBatchSigningAttempt());
  }

  ngOnDestroy(): void {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
    if (this.displaySubscription) {
      this.displaySubscription.unsubscribe();
    }
    if (this.reloadSubscription) {
      this.reloadSubscription.unsubscribe();
    }
  }

  startTimer() {
    this.timerSubscription = interval(1000)
      .pipe(takeWhile(() => this.timeLeft > 0))
      .subscribe(() => {
        this.timeLeft--;
        this.minutes = Math.floor(this.timeLeft / 60);
        this.seconds = this.timeLeft % 60;
        if (this.timeLeft === 0) {
          this.isLoading = false; // Hide spinner when timer ends
        }
      });
  }
}
